import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import { useLang } from "@/hooks/useLang";
import ProtectedAdminRoute from "@/routes/NavigationRoute/ProtectedAdminRoute";
import { AdminTheme } from "@/theme/Admin";

const CheckoutLogList = React.lazy(() => import("../modules/Eticket/components/Eticketing/CheckoutLog/List/CheckoutLogList.controller"));

const MobileRoutes: FC = () => {
    const { lang, getAdminLangPath } = useLang();

    return (
        <Routes>
            <Route element={<ProtectedAdminRoute />}>
                <Route element={<AdminTheme.Common.MobileLayout />}>
                    <Route path={getAdminLangPath(lang, "/e-ticket/checkout-logs")} element={<CheckoutLogList />}/>
                    <Route path={getAdminLangPath(lang, "/e-ticket/checkout-logs/:formType")} element={<CheckoutLogList />}/>
                </Route>
            </Route>
        </Routes>
    );
};

export default MobileRoutes;
